module.exports = __webpack_public_path__ + "static/media/image1.6155625a.png";